import { createFileRoute } from '@tanstack/react-router'
import { IntegrasiDesaPage } from '../../components/platform/IntegrasiDesaPage'

export const Route = createFileRoute('/platform/integrasi-desa')({
  component: IntegrasiDesaPage,
})
